import React from "react";
import { ProjectBasicDataType } from "../../../interface/interface";
import { formatDate } from "../../../lib/lib";

function ProjectCard({
  data: { prjt_type_cd, prjt_nm, apply_sts_at, apprv_sts_nm, rcrt_nm },
}: {
  data: ProjectBasicDataType;
}) {
  return (
    <div className="project-card">
      <div className={`category ${prjt_type_cd}`}>
        {prjt_type_cd === "prjt" ? "팀프로젝트" : "팀밋업"}
      </div>
      <div className="title">{prjt_nm}</div>
      <div className="timestamp">{formatDate(apply_sts_at, "-")}</div>
      <div className="paymenttime">{rcrt_nm}</div>
      <div className="price">{apprv_sts_nm}</div>
    </div>
  );
}

export default ProjectCard;
